import React, { useMemo, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Chart from "react-apexcharts";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TablePagination,
  Typography
} from "@material-ui/core";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import IconoResumenDiario from "../../assets/icons/icono-resumen-diario.png";
import { ArrowDown01, ArrowDown10 } from "../icons/TableUtils";

import { useMaquinasJustificacion } from "../../hooks/useMaquinasJustificacion";

import { getLocaleLanguage } from "../../commons/Idiomas";
import DateFnsUtils from "@date-io/date-fns";
import { useTranslation } from "react-i18next";
import {
  formatearFechaISOtoUSFormat,
  formatearMinutos
} from "../../commons/FormatearFecha";

import { TablaDeCarga } from "./TablaDeCarga";
import { useGetJustificacionPendientePerforadora } from "../../hooks/justificacion/useGetJustificacionPendientePerforadora";
import { useGetUltimaUbicacionPerforadoraByFecha } from "../../hooks/justificacion/useGetUltimaUbicacionPerforadoraByFecha";
import {
  getHorometroMotorJustificacion,
  justificarPerforadora
} from "../../services/justificacion";
import { getMovimientosMaquina } from "../../services/operaciones";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis
} from "recharts";
import { SkeletonBarChart } from "../../views/OperacionesMaquina/OperacionesJumbosLasChispas/components/SkeletonBarChart";
import { SkeletonLineChart } from "../../views/OperacionesMaquina/OperacionesJumbosLasChispas/components/SkeletonLineChart";
import { InfoCard, InfoIcon, InfoTitle } from "../atoms/InfoCard";
import { TiposMovimientos } from "./TiposMovimientos";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#2f4554",
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const opcionesJustificacionPerforadora = [
  { id: 228, id_justificacion_grupo: 37, nombre: "Cara libre" },
  { id: 229, id_justificacion_grupo: 37, nombre: "Disparo cerrado" },
  { id: 230, id_justificacion_grupo: 37, nombre: "Desperfecto mecánico" }
];

const JustificarPerforadoraButton = ({ maquina, classes, setForceRefresh }) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [selectedJustificacion, setSelectedJustificacion] = useState(null);
  const [error, setError] = useState(null);

  const [fechaInicio, horaInicio] = maquina.inicio_movimiento.split(" ");

  const {
    ultimaUbicacionPerforadora,
    getUltimaUbicacionPerforadora,
    loadingUltimaUbicacionPerforadora
  } = useGetUltimaUbicacionPerforadoraByFecha();

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = async () => {
    await getUltimaUbicacionPerforadora(
      maquina.id_maquina,
      fechaInicio,
      horaInicio
    );
    setOpenModal(true);
    setSelectedJustificacion(null);
  };

  const handleJustificacionChange = (event) => {
    const selectedId = Number(event.target.value);

    setSelectedJustificacion(selectedId);
  };

  const handleJustificar = async () => {
    setError(null);

    if (!selectedJustificacion) {
      setError(t("error_justificacion"));
      return;
    }

    const result = await justificarPerforadora(
      maquina,
      selectedJustificacion,
      ultimaUbicacionPerforadora
    );
    if (result.status === "success") {
      setOpenModal(false);
      setForceRefresh((prevRefresh) => prevRefresh + 1);
    }
  };

  return (
    <>
      <Button
        type="button"
        variant="contained"
        className={classes.root}
        onClick={handleOpenModal}>
        {t("justificar")}
      </Button>
      <Dialog
        open={openModal}
        onClose={handleCloseModal}>
        <DialogTitle>{t("justificar_perforadora")}</DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={2}>
            <Grid
              item
              xs={9}>
              <Typography variant="subtitle1">
                <span style={{ fontSize: "12px", color: "#808080" }}>
                  {t("ubicacion")}
                </span>
                <p
                  style={{
                    color: "#a8a8a8",
                    borderBottom: "1px dashed #a8a8a8"
                  }}>
                  {loadingUltimaUbicacionPerforadora
                    ? "Cargando..."
                    : ultimaUbicacionPerforadora || "-"}
                </p>
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}>
              <Typography variant="subtitle1">
                <span style={{ fontSize: "12px", color: "#808080" }}>
                  {t("equipo")}
                </span>
                <p
                  style={{
                    color: "#a8a8a8",
                    borderBottom: "1px dashed #a8a8a8"
                  }}>
                  {maquina.nombre_maquina}
                </p>
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}>
              <Typography variant="subtitle1">
                <span style={{ fontSize: "12px", color: "#808080" }}>
                  {t("fecha_inicio")}
                </span>
                <p
                  style={{
                    color: "#a8a8a8",
                    borderBottom: "1px dashed #a8a8a8"
                  }}>
                  {maquina.inicio_movimiento}
                </p>
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}>
              <Typography variant="subtitle1">
                <span style={{ fontSize: "12px", color: "#808080" }}>
                  {t("fecha_fin")}
                </span>
                <p
                  style={{
                    color: "#a8a8a8",
                    borderBottom: "1px dashed #a8a8a8"
                  }}>
                  {maquina.fin_movimiento}
                </p>
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}>
              <FormControl fullWidth>
                <Select
                  value={selectedJustificacion || ""}
                  onChange={handleJustificacionChange}
                  displayEmpty
                  fullWidth
                  style={{ height: "40px" }}>
                  <MenuItem
                    value=""
                    disabled>
                    {t("seleccione_opcion")}
                  </MenuItem>
                  {opcionesJustificacionPerforadora.map((opcion) => (
                    <MenuItem
                      key={opcion.id}
                      value={opcion.id}>
                      {t(opcion.nombre)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {error && (
                <Typography
                  variant="subtitle1"
                  color="error">
                  {error}
                </Typography>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>{t("cancelar")}</Button>
          <Button
            onClick={handleJustificar}
            disabled={!selectedJustificacion}
            color="primary">
            {t("confirmar")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles({
  table: {
    width: "100%"
  },
  root: {
    backgroundColor: "#2f4554",
    margin: "8px 0",
    color: "white",
    "&:hover": {
      backgroundColor: "#253642"
    },
    "&:disabled": {
      backgroundColor: "gray"
    }
  }
});

const tiposMovimientos = {
  2: "en_mantencion_justificacion",
  3: "fuera_de_servicio_justificacion",
  5: "ralenti_justificacion",
  6: "jumbo_justificacion"
};

function getMonthStartAndEnd(date) {
  const year = date.getFullYear();
  const month = date.getMonth();

  const start = new Date(year, month, 1);
  const end = new Date(year, month + 1, 0);

  const formatDate = (d) => d.toISOString().slice(0, 10);

  return [formatDate(start), formatDate(end)];
}

const MovimientosChart = ({ moves, date }) => {
  return (
    <ResponsiveContainer
      style={{ position: "relative" }}
      minWidth="100%"
      width="100%"
      height={550}>
      <LineChart
        data={moves}
        margin={{
          top: 45,
          bottom: 60,
          left: 60,
          right: 29
        }}>
        <XAxis
          style={{ userSelect: "none" }}
          dataKey="datetime"
          scale="time"
          type="number"
          domain={[
            new Date(`${date}T08:00:00`).getTime(),
            new Date(
              new Date(`${date}T08:00:00`).getTime() + 24 * 60 * 60 * 1000
            ).getTime()
          ]}
          tickFormatter={(tick) => {
            const d = new Date(tick);
            return `${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
          }}
        />
        <CartesianGrid
          horizontal={true}
          vertical={false}
          strokeDasharray="3 3"
          stroke="#E5E5E5"
        />
        <YAxis
          style={{ userSelect: "none", fontSize: "11.5px" }}
          scale="point"
          type="category"
          dataKey="descripcion"
          padding={{
            top: 20,
            bottom: 20
          }}
          tickMargin={2}
          tick={{ whiteSpace: "nowrap", width: 120 }}
        />
        <Line
          dot={true}
          strokeWidth={2}
          type="monotone"
          stroke="#4dc8d1"
          dataKey="descripcion"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

const tipoColors = {
  "Motor": "#01b7c4",
  "Justificar": "#c4046b"
};

function getColorForTipo(tipo) {
  if (tipoColors[tipo]) return tipoColors[tipo];

  const match = tipo.match(/^(Motor) \d+$/);

  if (match) {
    const baseTipo = match[1];

    return tipoColors[baseTipo] || "#01b7c4";
  }

  return "#01b7c4";
}

function getOrdenTipoBase(horometro) {
  const tiposBaseSet = new Set();
  let maxMotorN = 0;

  horometro.forEach((item) => {
    let tipo = item.tipo_movimiento;
    if (tipo.startsWith("fuera de servicio ")) {
      tipo = tipo.replace("fuera de servicio ", "");
    }
    tiposBaseSet.add(tipo);
    if (/^Motor (\d+)$/.test(tipo)) {
      const n = Number.parseInt(tipo.split(" ")[1], 10);
      maxMotorN = Math.max(maxMotorN, n);
    }
  });

  const ordenTipoBase = [];

  for (let i = 1; i <= maxMotorN; i++) {
    ordenTipoBase.push(`Motor ${i}`);
  }

  return ordenTipoBase;
}

function formatDateLocal(date) {
  if (date.includes(" ")) {
    const [datePart, timePart] = date.split(" ");
    const [year, month, day] = datePart.split("-");
    const [hours, minutes, seconds] = timePart.split(":");

    return new Date(
      Number.parseInt(year),
      Number.parseInt(month) - 1,
      Number.parseInt(day),
      Number.parseInt(hours),
      Number.parseInt(minutes),
      Number.parseInt(seconds)
    );
  }

  const now = new Date();
  const [year, month, day] = date.split("-");
  return new Date(
    Number.parseInt(year),
    Number.parseInt(month) - 1,
    Number.parseInt(day),
    now.getHours(),
    now.getMinutes(),
    now.getSeconds()
  );
}

const getTipoLabel = (t, tipoBase) => {
  const match = tipoBase.match(/^(Motor) (\d+)$/);
  if (match) {
    const [_, tipo, n] = match;
    return t(`${tipo}_n`, { n });
  }

  return t(tipoBase);
};

const HorometroChart = ({ horometroData, date }) => {
  const { t, i18n } = useTranslation();

  const getStartLimit = (date) => {
    const [year, month, day] = date.split("-");
    return new Date(
      Number.parseInt(year),
      Number.parseInt(month) - 1,
      Number.parseInt(day),
      8,
      0,
      0,
      0
    ).getTime();
  };

  const getEndLimit = (date) => {
    const today = new Date();
    const todayStr = today.toISOString().split("T")[0];

    if (date === todayStr) {
      return today.getTime();
    }

    const [year, month, day] = date.split("-");
    return new Date(
      Number.parseInt(year),
      Number.parseInt(month) - 1,
      Number.parseInt(day) + 1,
      8,
      0,
      0,
      0
    ).getTime();
  };

  const processedData = horometroData.map((item) => {
    const isFueraServicio =
      item.tipo_movimiento.startsWith("fuera de servicio");
    const tipoBase = isFueraServicio
      ? item.tipo_movimiento.replace("fuera de servicio ", "")
      : item.tipo_movimiento;
    const fechaInicio = formatDateLocal(item.fecha_inicio).getTime();
    const fechaFinal = formatDateLocal(item.fecha_fin).getTime();

    return {
      move: tipoBase,
      fueraDeServicio: isFueraServicio,
      data: [
        {
          x: getTipoLabel(t, tipoBase) || tipoBase,
          y: [fechaInicio, fechaFinal]
        }
      ]
    };
  });

  const startLimit = getStartLimit(date);
  const endLimit = getEndLimit(date);

  const adjustDataToRange = (data, min, max) => {
    return data.map((item) => ({
      ...item,
      data: item.data.map((d) => ({
        ...d,
        y: [Math.max(d.y[0], min), Math.min(d.y[1], max)]
      }))
    }));
  };

  const ordenTipoBase = getOrdenTipoBase(horometroData);
  const ordenTipo = ordenTipoBase.map((tipo) => getTipoLabel(t, tipo));

  const sortedData = processedData.sort((a, b) => {
    const orderA = ordenTipo.indexOf(a.data[0].x);
    const orderB = ordenTipo.indexOf(b.data[0].x);
    return (orderA === -1 ? 99 : orderA) - (orderB === -1 ? 99 : orderB);
  });

  const options = useMemo(() => {
    const effectiveMin = startLimit;
    const effectiveMax = endLimit;

    return {
      chart: {
        offsetX: -18,
        animations: {
          enabled: false
        },
        type: "rangeBar",
        zoom: {
          enabled: true,
          allowMouseWheelZoom: false,
          zoomedArea: {
            fill: {
              color: "#90CAF9",
              opacity: 0.1
            },
            stroke: {
              color: "#0D47A1",
              opacity: 0.1,
              width: 1
            }
          }
        },
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          rangeBarGroupRows: true,
          barHeight: "85%"
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        labels: {
          style: {
            fontSize: "11.5px",
            fontFamily: "inherit",
            fontWeight: 400,
            width: 120
          },
          minWidth: 111
        }
      },
      xaxis: {
        tickAmount: 12,
        axisBorder: {
          show: false
        },
        type: "datetime",
        dateTimeUTC: true,
        min: effectiveMin,
        max: effectiveMax,
        labels: {
          formatter: (val) => {
            if (!val) return "";

            const date = new Date(val);

            const timeToMax = Math.abs(val - effectiveMax);
            if (timeToMax < 1000 * 60 * 30) return "";

            return date
              .toLocaleString(i18n.language === "es" ? "es-CL" : "en-US", {
                day: "2-digit",
                month: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
              })
              .replace(":", ":");
          },
          hideOverlappingLabels: true,
          showDuplicates: false,
          style: {
            fontSize: "12px"
          },
          trim: true,
          tickPlacement: "on"
        }
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          formatter: (val) => {
            if (typeof val === "number") {
              const date = new Date(val);
              return date.toLocaleString(
                i18n.language === "es" ? "es-CL" : "en-US",
                {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: false
                }
              );
            }
            return val;
          }
        }
      },
      legend: {
        show: false
      },
      colors: [
        ({ seriesIndex, w }) => {
          const fueraDeServicio = w.config.series[seriesIndex].fueraDeServicio;

          if (fueraDeServicio) return "#c5283d";

          const move = w.config.series[seriesIndex].move;

          return getColorForTipo(move);
        }
      ],
      fill: {
        type: "solid",
        opacity: 0.7
      }
    };
  }, [startLimit, endLimit, i18n.language]);

  return (
    <section>
      <Chart
        options={options}
        type="rangeBar"
        series={adjustDataToRange(sortedData, startLimit, endLimit)}
        height="200px"
        width="100%"
      />
    </section>
  );
};

const ViewDetailsJustificacionPerforadora = ({ maquina }) => {
  const [open, setOpen] = useState(false);
  const [moves, setMoves] = useState([]);
  const [loadingMoves, setLoadingMoves] = useState(false);
  const [errorMoves, setErrorMoves] = useState(null);
  const date = maquina.inicio_movimiento.split(" ")[0];

  const [horometro, setHorometro] = useState([]);
  const [loadingHorometro, setLoadingHorometro] = useState(false);

  const { t } = useTranslation();

  const handleOpenModal = async () => {
    setOpen(true);
    setLoadingMoves(true);
    setLoadingHorometro(true);
    const { data, message, status } = await getMovimientosMaquina(
      maquina.id_maquina,
      date,
      date
    );

    const { data: horometro, status: statusHorometro } =
      await getHorometroMotorJustificacion(maquina.id_maquina, date);

    if (statusHorometro === "success") {
      const justificacionMaquina = {
        fecha_inicio: maquina.inicio_movimiento,
        fecha_fin: maquina.fin_movimiento,
        tipo_movimiento: "Justificar"
      };

      const newHorometro = [...horometro, justificacionMaquina];

      setHorometro(newHorometro);
    }

    setLoadingHorometro(false);

    if (status === "success") {
      setLoadingMoves(false);

      const now = new Date();
      const isToday = date === now.toISOString().split("T")[0];

      const minDate = new Date(`${date}T08:00:00`);

      let maxDate;
      if (isToday) {
        maxDate = now;
      } else {
        const nextDay = new Date(date);
        nextDay.setDate(nextDay.getDate() + 1);
        maxDate = new Date(`${nextDay.toISOString().split("T")[0]}T08:00:00`);
      }

      const processedData = data
        .map((item) => {
          const itemDate = new Date(
            `${item.fecha_inicial}T${item.hora_inicial}`
          );
          return {
            ...item,
            datetime: itemDate.getTime()
          };
        })
        .filter((item) => {
          const itemDate = new Date(item.datetime);
          const isAfterMin = itemDate >= minDate;
          const isBeforeMax = itemDate <= maxDate;

          return isAfterMin && isBeforeMax;
        });

      setMoves(processedData);
    }

    if (status === "no-data") {
      setLoadingMoves(false);
      setErrorMoves(message);
    }

    if (status === "error") {
      setLoadingMoves(false);
      setErrorMoves(message);
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <VisibilityIcon
        sx={{ cursor: "pointer" }}
        onClick={handleOpenModal}
      />
      <Dialog
        open={open}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="lg">
        <DialogTitle>
          <InfoCard>
            <InfoIcon
              style={{ width: "35px" }}
              src={IconoResumenDiario}
            />
            <InfoTitle>{t("movimiento_y_horometro")}</InfoTitle>
          </InfoCard>
        </DialogTitle>

        <DialogContent>
          <section>
            {loadingMoves && (
              <section style={{ marginBlockEnd: "40px" }}>
                <SkeletonLineChart height="415px" />
              </section>
            )}
            {errorMoves && <p>{errorMoves}</p>}
            {!loadingMoves && (
              <MovimientosChart
                moves={moves}
                date={date}
              />
            )}
          </section>
          <section>
            <TiposMovimientos />
          </section>
          <section>
            {loadingHorometro && (
              <section
                style={{ marginInlineStart: "10px", marginBlock: "20px" }}>
                <SkeletonBarChart rows={2} />
              </section>
            )}
            {!loadingHorometro && (
              <HorometroChart
                horometroData={horometro}
                date={date}
              />
            )}
          </section>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>{t("cerrar")}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export const TablaEquipos = ({
  abrirModal,
  id_area_operacion,
  equipos,
  formik,
  abrirModalCustom,
  abrirDetalle,
  setMostrarTiempoAJustificar
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [fecha, setFecha] = useState(new Date());
  const [forceRefresh, setForceRefresh] = useState(0);

  const [sortDate, setSortDate] = useState({
    field: null,
    direction: null
  });

  const [inicioMes, finMes] = getMonthStartAndEnd(fecha);

  const { justificacionPendiente } = useGetJustificacionPendientePerforadora(
    id_area_operacion,
    inicioMes,
    finMes
  );

  const { data: Maquinas, loading } = useMaquinasJustificacion(
    fecha,
    id_area_operacion,
    forceRefresh
  );
  const [maquinaSelected, setMaquinaSelected] = useState(0);
  const [alarmaSelected, setAlarmaSelected] = useState(0);

  const arregloMovimientos = [
    { id: 2, nombre: t("en_mantencion_justificacion") },
    { id: 3, nombre: t("fuera_de_servicio_justificacion") },
    { id: 5, nombre: t("ralenti_justificacion") },
    { id: 6, nombre: t("jumbo_justificacion") }
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onHandleSeleccionarMaquina = (e) => {
    const value = Number(e.target.value);
    setPage(0);
    setMaquinaSelected(value);
  };

  const onHandleSeleccionarAlarma = (e) => {
    const value = Number(e.target.value);
    setPage(0);
    setAlarmaSelected(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onHandleClickOpenModal = (
    maquina,
    fecha_inicio,
    fecha_termino,
    id_registro_movimiento,
    id_movimiento
  ) => {
    formik.setFieldValue("id_tipo_justificacion", 0);
    formik.setFieldValue("fecha_inicio", fecha_inicio);
    formik.setFieldValue("fecha_termino", fecha_termino);
    formik.setFieldValue("id_maquina", maquina);
    formik.setFieldValue("id_registro_movimiento", id_registro_movimiento);
    formik.setFieldValue("id_movimiento", id_movimiento);
    abrirModal(id_registro_movimiento, false);
  };

  const maquinas = useMemo(() => {
    let base = Maquinas;
    if (id_area_operacion === 29) {
      base =
        justificacionPendiente && justificacionPendiente.length > 0
          ? Maquinas.concat(justificacionPendiente)
          : Maquinas;
    }
    let result = base;
    if (maquinaSelected !== 0) {
      result = result.filter((m) => m.id_maquina === maquinaSelected);
    }
    if (alarmaSelected !== 0) {
      result = result.filter((m) => m.id_tipo_movimiento === alarmaSelected);
    }
    // Sort solo si hay campo y dirección
    if (sortDate.field && sortDate.direction) {
      result = [...result].sort((a, b) => {
        const field = sortDate.field;
        const order = sortDate.direction;
        const dateA = new Date(a[field]);
        const dateB = new Date(b[field]);
        if (order === "asc") {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      });
    }
    return result;
  }, [
    Maquinas,
    justificacionPendiente,
    id_area_operacion,
    maquinaSelected,
    alarmaSelected,
    sortDate
  ]);

  if (loading) {
    return (
      <>
        <TablaDeCarga
          columnas={[
            t("equipo"),
            t("Fecha inicio"),
            t("Fecha termino"),
            t("Duración"),
            t("Tipo alarma"),
            t("Acción")
          ]}
        />
      </>
    );
  }

  return (
    <>
      <Grid
        container
        style={{ marginBottom: "20px" }}>
        <MuiPickersUtilsProvider
          locale={getLocaleLanguage(i18n.language)}
          utils={DateFnsUtils}>
          <KeyboardDatePicker
            cancelLabel={t("cancelar")}
            className={classes.datepicker}
            size="small"
            inputVariant="outlined"
            openTo="month"
            minDate={new Date("2021-11-01 00:00:00")}
            maxDate={new Date().setHours(23, 59, 59)}
            views={["year", "month"]}
            value={fecha}
            onChange={(newValue) => {
              setPage(0);
              setFecha(newValue);
            }}
          />
        </MuiPickersUtilsProvider>

        <Box sx={{ minWidth: 240, marginLeft: 20 }}>
          <FormControl fullWidth>
            <Select
              style={{ height: "40px" }}
              name="id_maquina"
              defaultValue={0}
              labelId="razon-select-label"
              id="razon-select"
              value={maquinaSelected}
              label="Seleccione una opción"
              onChange={(e) => {
                onHandleSeleccionarMaquina(e);
              }}>
              <MenuItem
                key={0}
                value={0}>
                {t("todos_los_equipos")}
              </MenuItem>
              {equipos.map((equipo) => (
                <MenuItem
                  key={equipo.id}
                  value={equipo.id}>
                  {equipo.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ minWidth: 240, marginLeft: 20 }}>
          <FormControl fullWidth>
            <Select
              style={{ height: "40px" }}
              name="id_maquina"
              defaultValue={0}
              labelId="razon-select-label"
              id="razon-select"
              value={alarmaSelected}
              label="Seleccione una opción"
              onChange={(e) => {
                onHandleSeleccionarAlarma(e);
              }}>
              <MenuItem
                key={0}
                value={0}>
                {t("todas_las_alarmas")}
              </MenuItem>
              {arregloMovimientos.map((mov) => (
                <MenuItem
                  key={mov.id}
                  value={mov.id}>
                  {mov.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ minWidth: 240, marginLeft: 20 }}>
          <Button
            type="button"
            variant="contained"
            className={classes.root}
            onClick={() => {
              formik.resetForm();
              abrirModalCustom();
            }}>
            {t("justificacion_personalizada")}
          </Button>
        </Box>
      </Grid>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="left">{t("equipo")}</StyledTableCell>
              <StyledTableCell
                align="left"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSortDate((prev) => {
                    if (prev.field !== "inicio_movimiento") {
                      return { field: "inicio_movimiento", direction: "desc" };
                    } else if (prev.direction === "desc") {
                      return { field: "inicio_movimiento", direction: "asc" };
                    } else if (prev.direction === "asc") {
                      return { field: null, direction: null };
                    } else {
                      return { field: "inicio_movimiento", direction: "desc" };
                    }
                  });
                }}>
                <span style={{ userSelect: "none" }}>{t("fecha_inicio")}</span>
                <span style={{ marginLeft: 8 }}>
                  {sortDate.field === "inicio_movimiento" &&
                    sortDate.direction === "asc" && (
                      <ArrowDown01
                        style={{ verticalAlign: "middle", color: "#01b7c4" }}
                      />
                    )}
                  {sortDate.field === "inicio_movimiento" &&
                    sortDate.direction === "desc" && (
                      <ArrowDown10
                        style={{ verticalAlign: "middle", color: "#01b7c4" }}
                      />
                    )}
                  {(!sortDate.field ||
                    sortDate.field !== "inicio_movimiento") && (
                    <ArrowDown01
                      style={{
                        verticalAlign: "middle",
                        color: "#888",
                        opacity: 0.6
                      }}
                    />
                  )}
                </span>
              </StyledTableCell>
              <StyledTableCell
                align="left"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSortDate((prev) => {
                    if (prev.field !== "fin_movimiento") {
                      return { field: "fin_movimiento", direction: "desc" };
                    } else if (prev.direction === "desc") {
                      return { field: "fin_movimiento", direction: "asc" };
                    } else if (prev.direction === "asc") {
                      return { field: null, direction: null };
                    } else {
                      return { field: "fin_movimiento", direction: "desc" };
                    }
                  });
                }}>
                <span style={{ userSelect: "none" }}>{t("fecha_fin")}</span>
                <span style={{ marginLeft: 8 }}>
                  {sortDate.field === "fin_movimiento" &&
                    sortDate.direction === "asc" && (
                      <ArrowDown01
                        style={{ verticalAlign: "middle", color: "#01b7c4" }}
                      />
                    )}
                  {sortDate.field === "fin_movimiento" &&
                    sortDate.direction === "desc" && (
                      <ArrowDown10
                        style={{ verticalAlign: "middle", color: "#01b7c4" }}
                      />
                    )}
                  {(!sortDate.field || sortDate.field !== "fin_movimiento") && (
                    <ArrowDown01
                      style={{
                        verticalAlign: "middle",
                        color: "#888",
                        opacity: 0.6
                      }}
                    />
                  )}
                </span>
              </StyledTableCell>
              <StyledTableCell align="left">{t("duracion")}</StyledTableCell>
              <StyledTableCell align="left">{t("tipo_alarma")}</StyledTableCell>
              <StyledTableCell align="left">{t("accion")}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && maquinas.length < 1 && (
              <StyledTableRow>
                <StyledTableCell
                  colSpan={6}
                  align="center">
                  <b>{t("sin_info")}</b>
                </StyledTableCell>
              </StyledTableRow>
            )}
            {maquinas
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((maquina) => {
                const isPercussion = maquina.id_tipo_movimiento === 6;

                return (
                  <StyledTableRow key={maquina.id}>
                    <StyledTableCell
                      align="left"
                      component="th"
                      scope="row">
                      {t(maquina.nombre_maquina)}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {isPercussion
                        ? maquina.inicio_movimiento
                        : formatearFechaISOtoUSFormat(
                            maquina.inicio_movimiento
                          )}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {isPercussion
                        ? maquina.fin_movimiento
                        : formatearFechaISOtoUSFormat(maquina.fin_movimiento)}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {formatearMinutos(maquina.duracion_minutos_movimiento)}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {t(tiposMovimientos[maquina.id_tipo_movimiento])}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-evenly">
                        {maquina.id_tipo_movimiento === 6 ? (
                          <JustificarPerforadoraButton
                            setForceRefresh={setForceRefresh}
                            maquina={maquina}
                            classes={classes}
                          />
                        ) : (
                          <Button
                            type="button"
                            variant="contained"
                            className={classes.root}
                            onClick={() => {
                              onHandleClickOpenModal(
                                maquina.id_maquina,
                                formatearFechaISOtoUSFormat(
                                  maquina.inicio_movimiento
                                ),
                                formatearFechaISOtoUSFormat(
                                  maquina.fin_movimiento
                                ),
                                maquina.id,
                                maquina.id_tipo_movimiento
                              );
                            }}>
                            {t("justificar")}
                          </Button>
                        )}
                        {maquina.id_tipo_movimiento === 6 ? (
                          <ViewDetailsJustificacionPerforadora
                            maquina={maquina}
                          />
                        ) : (
                          <VisibilityIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              const fechaHoraString = maquina.dia;
                              const fechaHora = new Date(fechaHoraString);
                              const fechaFormateada = fechaHora
                                .toISOString()
                                .split("T")[0];

                              localStorage.setItem("idMina", id_area_operacion);
                              localStorage.setItem(
                                "idMaquina",
                                maquina.id_maquina
                              );
                              localStorage.setItem(
                                "diaJustificacionDetalle",
                                fechaFormateada
                              );
                              localStorage.setItem(
                                "nombreMaquinaJustificado",
                                t(maquina.nombre_maquina)
                              );
                              localStorage.setItem(
                                "fechaInicioJustificacionPendiente",
                                formatearFechaISOtoUSFormat(
                                  maquina.inicio_movimiento
                                )
                              );
                              setMostrarTiempoAJustificar(true);
                              abrirDetalle(true);
                            }}
                          />
                        )}
                      </Grid>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10]}
          component="div"
          count={maquinas.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={t("filas_por_pagina")}
        />
      </TableContainer>
    </>
  );
};
